import React from "react"
import { Button, CircularProgress } from "@mui/material"
import { AlertCircle } from "lucide-mui"
import i18n from "@/i18n"

interface UploadingPhotoItemProps {
  previewUrl: string
  uploading: boolean
  error: boolean
  onRetry: () => void
}

const STYLES = {
  container: "relative w-full pb-[50%] rounded-lg overflow-hidden",
  image: "absolute inset-0 w-full h-full object-cover",
  loadingOverlay: "absolute inset-0 flex items-center justify-center",
  errorOverlay: "absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center gap-2",
  errorIcon: "w-10 h-10 text-red-500",
  errorText: "text-white text-sm",
} as const

const UploadingPhotoItem: React.FC<UploadingPhotoItemProps> = ({ previewUrl, uploading, error, onRetry }) => {
  return (
    <div className={STYLES.container} data-testid="settings-venue-photo-uploading">
      <img src={previewUrl} alt="Uploading" className={STYLES.image} style={{ opacity: uploading ? 0.5 : 1 }} />
      {uploading && (
        <div className={STYLES.loadingOverlay}>
          <CircularProgress size={40} />
        </div>
      )}
      {error && (
        <div className={STYLES.errorOverlay}>
          <AlertCircle className={STYLES.errorIcon} />
          <p className={STYLES.errorText}>{i18n.t("app.settings.venues.tabbio.photos.upload_failure")}</p>
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={onRetry}
            data-testid="settings-venue-photo-uploading-btn-retry"
          >
            {i18n.t("app.settings.venues.tabbio.photos.upload_failure_retry")}
          </Button>
        </div>
      )}
    </div>
  )
}

export default UploadingPhotoItem
